(function () {
  'use strict';

  var PLUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><rect width="40" height="40" rx="5" fill="#CEC09F"/><path d="M19.301 13H20.785V19.3H27.085V20.784H20.785V27.084H19.301V20.784H13.001V19.3H19.301V13Z" fill="white"/></svg>';
  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><rect width="40" height="40" rx="5" fill="#78845e"/><path d="M12 20.5l5.5 5.5 10.5-11" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';

  var COLOR_MAP = {
    black: '#191A19', white: '#F4F3EE', grey: '#D0CEC9', gray: '#D0CEC9',
    navy: '#212D45', 'deep navy': '#212D45', deepnavy: '#212D45', blue: '#BEDEEE', 'light blue': '#BEDEEE', lightblue: '#BEDEEE', 'ocean blue': '#BEDEEE',
    olive: '#848C6C', green: '#3D8A3D', rose: '#C0B0BC', maroon: '#654342',
    brown: '#5A3C28', mocha: '#6C5F55', mocca: '#6C5F55', beige: '#D8CDBD',
    taupe: '#8E7E72', anthracite: '#3E4244', charcoal: '#3A3D40',
    red: '#C83030', pink: '#E88FA8', purple: '#7B4FA6', orange: '#E07830',
    cream: '#FFF0DC', ivory: '#F0EEE0', sand: '#C8B888', khaki: '#B8A870',
    camel: '#B89060', tan: '#C0A080', nude: '#D8A880', blush: '#E8C0BC',
    rust: '#A84020', wine: '#6A2030', burgundy: '#6A2030', sage: '#7EA068',
    mint: '#7DCCA4', teal: '#2E8080', cobalt: '#1A3C90', indigo: '#303098',
    lilac: '#A880CC', lavender: '#9880C0', violet: '#6030A0', coral: '#E06860',
    salmon: '#E07860', mustard: '#C8A030', gold: '#C0900C', copper: '#A06040',
    silver: '#909090', stone: '#908880', chocolate: '#5A2E18', emerald: '#2A7050',
    fuchsia: '#C02090', turquoise: '#2898A0', magenta: '#C03080',
  };

  var SWATCH_IMAGE_MAP = {
    'multicolor 1': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-1.svg?v=1787137731',
    'multicolor 2': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-2.svg?v=1787137731',
    'multicolor 3': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-3.svg?v=1787137731',
    'multicolor 4': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-4.svg?v=1787137731',
    'multicolor 5': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-5.svg?v=1787137731',
    'navy - beige': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/navy-beige.svg?v=1787139254',
    'mocca / beige': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/mocca-beige.svg?v=1787139254',
    'white / beige': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/white-beige.svg?v=1787139254',
    'olive / beige': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/olive-beige.svg?v=1787139254',
    'light blue / deep navy': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/l-blue-d-navy.svg?v=1787139254',
    'white / deep navy': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/white-navy.svg?v=1787139254',
    'beige / deep navy': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/beige-navy.svg?v=1787139254',
    'white / mocca': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/white-mocca.svg?v=1787139254',
    'beige / black': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/beige-black.svg?v=1787139255',
    'mocca / black': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/mocca-black.svg?v=1787139254',
    'maroon / beige': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/maroon-beige.svg?v=1787140087',
    'light blue / beige': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/l-blue-beige.svg?v=1787140087',
    'beige / mocca': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/beige-mocca.svg?v=1787140087',
    'olive / deep navy': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/olive-navy.svg?v=1787140359',
    'navy / beige': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/navy-beige-2.svg?v=1787140338',
    'multicolor 6': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multicolor-6.svg?v=1787141163',
    'mixed 3 pack 1': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-7.svg?v=1787141400',
    'mixed 3 pack 2': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-8.svg?v=1787141400',
    'mixed 3 pack 3': 'https://cdn.shopify.com/s/files/1/0945/3453/3459/files/multi-9.svg?v=1787141400'
  };

  function colorCSS(name) {
    if (!name) return '#D0CEC9';
    return COLOR_MAP[name.toLowerCase().trim()] || '#D0CEC9';
  }

  function getSwatchData(title) {
    var cleanTitle = (title || '').trim();
    var normalizedTitle = cleanTitle.toLowerCase();
    var imageName = Object.keys(SWATCH_IMAGE_MAP).find(function (name) {
      return normalizedTitle === name || normalizedTitle.endsWith(' - ' + name);
    });
    if (imageName) {
      return { colorName: cleanTitle.slice(-imageName.length), imageUrl: SWATCH_IMAGE_MAP[imageName] };
    }
    var parts = cleanTitle.split(' - ');
    return { colorName: parts.length > 1 ? parts[parts.length - 1] : parts[0] || '', imageUrl: '' };
  }

  function shopifyImg(src, size) {
    if (!src) return '';
    return src.replace(/(\.(jpg|jpeg|png|gif|webp))(\?.*)?$/i, '_' + size + 'x$1$3');
  }

  var SWATCH_CACHE   = {};
  var SWATCH_PENDING = {};

  function fetchSiblings(productId) {
    if (SWATCH_CACHE[productId])  return Promise.resolve(SWATCH_CACHE[productId]);
    if (SWATCH_PENDING[productId]) return SWATCH_PENDING[productId];
    var p = fetch('/recommendations/products.json?product_id=' + productId + '&intent=complementary&limit=12')
      .then(function (r) { return r.json(); })
      .then(function (d) { var s = d.products || []; SWATCH_CACHE[productId] = s; delete SWATCH_PENDING[productId]; return s; })
      .catch(function () { return []; });
    SWATCH_PENDING[productId] = p;
    return p;
  }

  function loadOverlaySwatches(section) {
    section.querySelectorAll('.stfl2__dyn-swatches[data-product-id]:not([data-swatches-loaded])').forEach(function (container) {
      container.dataset.swatchesLoaded = 'true';

      var productId     = container.dataset.productId;
      var originalTitle = container.dataset.originalTitle || '';
      var card          = container.closest('.stfl2__overlay-card');
      var imgWrap       = card  ? card.querySelector('.stfl2__overlay-img-wrap') : null;
      var img           = imgWrap ? imgWrap.querySelector('img') : null;
      var titleEl       = card  ? card.querySelector('.stfl2__overlay-title') : null;
      var plusBtn       = card  ? card.querySelector('.stfl2__atc-plus') : null;
      var col           = container.closest('.stfl2__overlay-swatches-col');
      var label         = col   ? col.querySelector('.product-card-v2__color-label') : null;
      var variantsScript = card ? card.querySelector('.stfl2__variants-json') : null;

      var origParts = (originalTitle || '').split(' - ');
      var origSwatch = getSwatchData(originalTitle);
      var origBaseTitle = origParts[0] || '';
      var origColor = origSwatch.colorName;
      var origImg   = img ? img.src : '';
      var origSrcset = img ? img.getAttribute('srcset') || '' : '';
      var origHref  = imgWrap ? imgWrap.getAttribute('href') : '';
      var origTitleHref = titleEl ? titleEl.getAttribute('href') : '';
      var origImgAlt = img ? img.getAttribute('alt') || '' : '';
      var origVariants = [];

      try {
        origVariants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
      } catch (e) {}

      if (origColor && label) label.textContent = origColor;

      function setCardState(state) {
        if (!card) return;

        if (img) {
          if (state.image) {
            img.src = state.image;
            if (state.srcset) {
              img.srcset = state.srcset;
            } else {
              img.removeAttribute('srcset');
            }
          } else {
            img.removeAttribute('srcset');
          }

          if (state.alt) img.alt = state.alt;
        }

        if (imgWrap && state.url) imgWrap.href = state.url;
        if (titleEl) {
          titleEl.textContent = state.baseTitle || origBaseTitle;
          if (state.url) titleEl.href = state.url;
        }

        if (plusBtn) {
          plusBtn.dataset.productId = String(state.productId || productId);
          plusBtn.setAttribute('aria-label', 'Kies maat voor ' + (state.baseTitle || origBaseTitle));
        }

        if (variantsScript && state.variants) {
          variantsScript.textContent = JSON.stringify(state.variants);
        }

        card.dataset.currentProductId = String(state.productId || productId);
      }

      function buildSwatch(colorName, isActive, state) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-card-v2__swatch' + (isActive ? ' is-active' : '');
        var imageUrl = SWATCH_IMAGE_MAP[colorName.toLowerCase().trim()];
        if (imageUrl) {
          btn.style.background = 'url("' + imageUrl + '") center / cover no-repeat';
        } else {
          btn.style.backgroundColor = colorCSS(colorName);
        }
        btn.setAttribute('aria-label', colorName);
        btn.dataset.colorName = colorName;
        btn.addEventListener('click', function () {
          container.querySelectorAll('.product-card-v2__swatch').forEach(function (s) { s.classList.remove('is-active'); });
          btn.classList.add('is-active');
          if (label) label.textContent = colorName;
          setCardState(state);
        });
        return btn;
      }

      setCardState({
        productId: productId,
        baseTitle: origBaseTitle,
        image: origImg,
        srcset: origSrcset,
        alt: origImgAlt,
        url: origHref || origTitleHref,
        variants: origVariants
      });

      // Original product swatch (always first, always active)
      if (origColor) {
        container.appendChild(buildSwatch(origColor, true, {
          productId: productId,
          baseTitle: origBaseTitle,
          image: origImg,
          srcset: origSrcset,
          alt: origImgAlt,
          url: origHref || origTitleHref,
          variants: origVariants
        }));
      }

      fetchSiblings(productId).then(function (siblings) {
        var seenColors = {};
        if (origColor) seenColors[origColor.toLowerCase().trim()] = true;

        siblings.forEach(function (sibling) {
          var parts = (sibling.title || '').split(' - ');
          var siblingSwatch = getSwatchData(sibling.title);
          var baseTitle = parts[0] || origBaseTitle;
          var colorName = siblingSwatch.colorName;
          if (!colorName) return;
          var colorKey = colorName.toLowerCase().trim();
          if (seenColors[colorKey]) return;
          seenColors[colorKey] = true;

          var sibImgSrc = sibling.featured_image
            ? (sibling.featured_image.src || sibling.featured_image)
            : '';
          var sibSrcset = sibImgSrc
            ? [150, 200, 300].map(function (width) {
                return shopifyImg(sibImgSrc, width) + ' ' + width + 'w';
              }).join(', ')
            : '';
          var sibUrl  = sibling.url || '';
          var sibAlt  = sibling.featured_image ? (sibling.featured_image.alt || sibling.title || '') : '';
          var sibVariants = sibling.variants || [];

          container.appendChild(buildSwatch(colorName, false, {
            productId: sibling.id,
            baseTitle: baseTitle,
            image: sibImgSrc,
            srcset: sibSrcset,
            alt: sibAlt,
            url: sibUrl,
            variants: sibVariants
          }));
        });
      });
    });
  }

  function initStfl2(section) {
    if (section.dataset.stfl2Init) return;
    section.dataset.stfl2Init = 'true';

    var sid = section.dataset.sectionId;
    var outer        = document.getElementById('stfl2-outer-' + sid);
    var mobileLabel  = document.getElementById('stfl2-mobile-label-' + sid);
    var mobileCtr    = document.getElementById('stfl2-mobile-counter-' + sid);
    var desktopLabel = document.getElementById('stfl2-desktop-label-' + sid);
    var desktopCtr   = document.getElementById('stfl2-desktop-counter-' + sid);
    var prevBtn      = document.getElementById('stfl2-prev-' + sid);
    var nextBtn      = document.getElementById('stfl2-next-' + sid);
    var dotsWrap     = document.getElementById('stfl2-dots-' + sid);
    var backdrop     = document.getElementById('stfl2-backdrop-' + sid);
    var sizePicker   = document.getElementById('stfl2-size-picker-' + sid);
    var sizeGrid     = document.getElementById('stfl2-size-grid-' + sid);
    var sizeClose    = document.getElementById('stfl2-size-close-' + sid);

    var blocks = outer ? Array.from(outer.querySelectorAll('.stfl2__block')) : [];
    var dots   = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.stfl2__dot')) : [];
    if (!outer || !blocks.length) return;

    var blockCount    = blocks.length;
    var activePlusBtn = null;

    // ── Outer scroll sync ───────────────────────────────────────────────────
    function outerIdx() {
      return outer.clientWidth > 0 ? Math.round(outer.scrollLeft / outer.clientWidth) : 0;
    }

    // ── Carousel-aware video facade ──────────────────────────────────────────
    // The active slide's video is loaded/played once the section has scrolled
    // near the viewport. Its immediate neighbors are prefetched (loaded, not
    // played) in the background so the next/previous swipe has no fetch delay.
    // Further-away slides stay dormant (data-src, never fetched) until reached.
    var activeVideoIdx = -1;
    var sectionInView  = false;

    function loadVideoEl(video, shouldPlay) {
      var src = video.dataset.src;
      if (!src) return;
      video.addEventListener('loadeddata', function () { video.classList.add('is-ready'); }, { once: true });
      video.src = src;
      delete video.dataset.src;
      video.load();
      if (shouldPlay) video.play().catch(function () {});
    }

    function prefetchVideoAt(idx) {
      var block = blocks[idx];
      var video = block ? block.querySelector('.stfl2__video') : null;
      if (video && video.dataset.src) loadVideoEl(video, false);
    }

    function activateVideo(idx) {
      if (idx === activeVideoIdx) return;

      if (activeVideoIdx !== -1 && blocks[activeVideoIdx]) {
        var prevVideo = blocks[activeVideoIdx].querySelector('.stfl2__video');
        if (prevVideo) prevVideo.pause();
      }

      var block = blocks[idx];
      var video = block ? block.querySelector('.stfl2__video') : null;
      if (video) {
        if (video.dataset.src) {
          loadVideoEl(video, true);
        } else {
          video.play().catch(function () {});
        }
      }

      activeVideoIdx = idx;

      // Prefetch the neighboring slides so the next/previous swipe is instant.
      prefetchVideoAt(idx + 1);
      prefetchVideoAt(idx - 1);
    }

    if (!('IntersectionObserver' in window)) {
      sectionInView = true;
      activateVideo(outerIdx());
    } else {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          sectionInView = true;
          activateVideo(outerIdx());
          videoObserver.disconnect();
        });
      }, { rootMargin: '600px 0px' });
      videoObserver.observe(section);
    }

    function syncOuter() {
      var idx   = outerIdx();
      var block = blocks[idx];
      if (!block) return;
      var label = block.dataset.label || '';

      if (mobileLabel)  mobileLabel.textContent  = label;
      if (mobileCtr)    mobileCtr.textContent     = (idx + 1) + '/' + blockCount;
      if (desktopLabel) desktopLabel.textContent  = label;
      if (desktopCtr)   desktopCtr.textContent    = (idx + 1) + '/' + blockCount;
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === blockCount - 1;

      if (sectionInView) activateVideo(idx);

      loadOverlaySwatches(block);

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    outer.addEventListener('scroll', syncOuter, { passive: true });
    syncOuter();

    // ── Desktop arrow navigation ─────────────────────────────────────────────
    function goTo(idx) {
      outer.scrollTo({ left: idx * outer.clientWidth, behavior: 'smooth' });
    }
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(Math.max(0, outerIdx() - 1)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(Math.min(blockCount - 1, outerIdx() + 1)); });

    // ── Size picker ──────────────────────────────────────────────────────────
    function showPicker(plusBtn, variants) {
      activePlusBtn = plusBtn;
      sizeGrid.innerHTML = '';
      variants.forEach(function (v) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'stfl2-size-picker__size-btn';
        btn.textContent = v.title;
        if (!v.available) btn.disabled = true;
        btn.addEventListener('click', function () {
          atcFromPicker(v.id, plusBtn);
        });
        sizeGrid.appendChild(btn);
      });
      sizePicker.classList.add('is-open');
      backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closePicker() {
      sizePicker.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
      activePlusBtn = null;
    }

    function atcFromPicker(variantId, plusBtn) {
      closePicker();
      if (plusBtn) {
        var orig = plusBtn.innerHTML;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        })
        .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
        .then(function () {
          plusBtn.innerHTML = CHECK_SVG;
          setTimeout(function () { plusBtn.innerHTML = orig; }, 2200);
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('cart-count').forEach(function (el) { el.itemCount = cart.item_count; });
          document.querySelectorAll('cart-dot').forEach(function (el) { el.classList.toggle('is-visible', cart.item_count > 0); });
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        })
        .catch(function () {});
      }
    }

    if (sizeClose) sizeClose.addEventListener('click', closePicker);
    if (backdrop)  backdrop.addEventListener('click', closePicker);

    // ── + button click ───────────────────────────────────────────────────────
    section.querySelectorAll('.stfl2__atc-plus').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var card = btn.closest('.stfl2__overlay-card');
        if (!card) return;
        var script = card.querySelector('.stfl2__variants-json');
        var variants = [];
        try { variants = JSON.parse(script.textContent); } catch (ex) { return; }
        if (!variants.length) return;
        if (variants.length === 1 && variants[0].available) {
          atcFromPicker(variants[0].id, btn);
          return;
        }
        showPicker(btn, variants);
      });
    });
  }

  function init() {
    document.querySelectorAll('.stfl2-section').forEach(initStfl2);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
